import { type AppTheme, themes } from "./theme";
import type { ThemeName } from "./tokens";
import { useTheme } from "./useTheme";

/**
 * Creates a `useStyles()` hook whose styles are built once per theme and reused (R7).
 * Usage: `const useStyles = makeStyles((t) => StyleSheet.create({ ... }));`
 */
export function makeStyles<S>(factory: (theme: AppTheme) => S): () => S {
  const cache: Partial<Record<ThemeName, S>> = {};
  return function useStyles(): S {
    const { resolved } = useTheme();
    let styles = cache[resolved];
    if (styles === undefined) {
      styles = factory(themes[resolved]);
      cache[resolved] = styles;
    }
    return styles;
  };
}
